import { type TargetType, Targets } from '@atlassiansox/cross-flow-support';
import type { Environment } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import { FIRST_PARTY_CCP_PRODUCT_IDS } from '@atlassian/surface-analytics';

export const SIDEBAR_WIDTH = 365;
export const SIDEBAR_WIDTH_REFRESH = 400;
export const PANEL_ID = 'recommendationsInProjectList';
export const HOVER_ANCHOR_ID = 'recommendationsInProjectListHoverAnchor';
export const PROJECT_CREATE_SOURCE = 'recommendationsInProjectList';

export const PROJECT_TYPE_TARGETS_MAP: Record<string, TargetType> = {
	BUSINESS: Targets.JIRA_CORE,
	SOFTWARE: Targets.JIRA_SOFTWARE,
	SERVICE_DESK: Targets.JIRA_SERVICE_DESK,
	PRODUCT_DISCOVERY: Targets.JIRA_PRODUCT_DISCOVERY,
};

export const getProductTypeCcpReferenceIdMapForEnv = (
	environment: Environment,
): Record<string, string> => {
	const env = environment === 'prod' ? 'prod' : 'staging';
	return {
		BUSINESS: FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_work_management_cloud,
		SOFTWARE: FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_software_cloud,
		SERVICE_DESK: FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_service_management_cloud,
		PRODUCT_DISCOVERY: FIRST_PARTY_CCP_PRODUCT_IDS[env].jira_product_discovery,
	};
};
